import { GraphObject, InputEvent, Node } from 'gojs';
import { highlightAncestors, highlightPredecessors } from '../../../utils/highlight-utils';

export const nodeMouseHover = (e: InputEvent, object: GraphObject) => {
  try {
    e.diagram.clearHighlighteds();
    highlightPredecessors(object as Node);
    highlightAncestors(object as Node);
  } catch (err) {
    e.diagram.clearHighlighteds();
  }
};

export const nodeMouseLeave = (e: InputEvent) => {
  e.diagram.clearHighlighteds();
};
